export default __webpack_public_path__ + "static/media/NFTCats-only100-in1season-4x.5309eb68.png";